import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TMessage } from "../../types/types";
type TMessageList = { [id: string]: TMessage };
type RoomInformation = {
  isOtherWithPubkey: boolean;
  isOtherTyping: boolean;
  isOtherJoined: boolean;
  messageList: TMessageList;
};
type TInitRoom = {
  toAddress: string;
  historyMessageList: Array<TMessage>;
};
type TDMTarget = {
  toAddress: string;
  alias: string;
};
type TDMState = {
  roomInformations: { [toAddress: string]: RoomInformation };
  lastDMTarget: TDMTarget;
};

const initialState: TDMState = {
  roomInformations: {},
  lastDMTarget: { toAddress: "", alias: "" },
};
type TUpdateRoomTyping = { toAddress: string; isOtherTyping: boolean };
type TUpdateRoomMessages = { toAddress: string; message: TMessage };
export const dmStateSlice = createSlice({
  name: "dmState",
  initialState,
  reducers: {
    updateRoomMessages: (state, action: PayloadAction<TUpdateRoomMessages>) => {
      const toAddress = action.payload.toAddress;
      const message = action.payload.message;
      if (!state.roomInformations[toAddress])
        state.roomInformations[toAddress] = {
          isOtherTyping: false,
          messageList: {},
        } as RoomInformation;
      state.roomInformations[toAddress].messageList[message.id] = message;
    },
    updateRoomTyping: (state, action: PayloadAction<TUpdateRoomTyping>) => {
      const toAddress = action.payload.toAddress;
      const isOtherTyping = action.payload.isOtherTyping;
      if (!state.roomInformations[toAddress]) return;
      state.roomInformations[toAddress].isOtherTyping = isOtherTyping;
    },
    initRoomInfomation: (state, action: PayloadAction<TInitRoom>) => {
      const toAddress = action.payload.toAddress;
      if (!state.roomInformations[toAddress])
        state.roomInformations[toAddress] = {
          isOtherTyping: false,
          isOtherJoined: false,
          isOtherWithPubkey: true,
          messageList: {},
        } as RoomInformation;
      action.payload.historyMessageList.forEach((message) => {
        state.roomInformations[toAddress].messageList[message.id] = message;
      });
    },
    setLastDMTarget: (state, action: PayloadAction<TDMTarget>) => {
      state.lastDMTarget = action.payload;
    },
  },
});
// Action creators are generated for each case reducer function
export const {
  updateRoomMessages,
  initRoomInfomation,
  updateRoomTyping,
  setLastDMTarget,
} = dmStateSlice.actions;
export default dmStateSlice.reducer;
